import { render, staticRenderFns } from "./StockExpiryNotification.vue?vue&type=template&id=f983e0e0&scoped=true&"
import script from "./StockExpiryNotification.vue?vue&type=script&lang=js&"
export * from "./StockExpiryNotification.vue?vue&type=script&lang=js&"
import style0 from "./StockExpiryNotification.vue?vue&type=style&index=0&id=f983e0e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f983e0e0",
  null
  
)

export default component.exports